import type { Theme } from '@/@types/theme';
import { theme1xpixColors } from '@/themes/brandColors/1xpix';

export const Theme1xpix: Theme = {
  name: '1xpix',
  dark: true,
  colors: theme1xpixColors,
};
